export function firstNonEmptyStringValue(...values: unknown[]): string | undefined {
  for (const value of values) {
    if (typeof value !== 'string') continue;
    const trimmed = value.trim();
    if (trimmed.length > 0) return trimmed;
  }
  return undefined;
}

export function nonEmptyStringList(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  return value
    .filter((item): item is string => typeof item === 'string' && item.trim().length > 0)
    .map((item) => item.trim());
}

export function normalizeFindSimilarPayload(payload: Record<string, unknown>): Record<string, unknown> {
  const next = { ...payload };
  const sku = firstNonEmptyStringValue(next['sku']);
  const groupSkus = nonEmptyStringList(next['group_skus']);

  if (sku) next['sku'] = sku;
  else delete next['sku'];

  if (groupSkus.length > 0) next['group_skus'] = groupSkus;
  else delete next['group_skus'];

  if (sku || groupSkus.length > 0) {
    delete next['image_url'];
  } else {
    const imageUrl = firstNonEmptyStringValue(next['image_url']);
    if (imageUrl) next['image_url'] = imageUrl;
    else delete next['image_url'];
  }

  return next;
}
